import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get, save } from "../requests/session";
import { createSignal, onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";

export default function useTherapySessionForm() {

  const navigate = useNavigate();

  const [loading, setLoading] = createSignal(false);
  const [key, setKey] = createSignal(null);
  const [therapy, setTherapy] = createSignal(null);
  const [attachments, setAttachments] = createSignal(null);
  const [form, setForm] = createStore({
    title: "",
    objectives: "",
    instructions: "",
    instructionsUrdu: "",
  });

  const fetchInfo = async (pid) => {
    setLoading(true);
    setKey(pid);
    try {
      const data = await get(key());
      setForm('title', data.entity.title);
      setForm('objectives', data.entity.objectives);
      setForm('instructions', data.entity.instructions);
      setForm('instructionsUrdu', data.entity.instructionsUrdu);
      setForm('attachments', data.entity.attachments);
    } catch (error) {
      throw error;
    }  finally {
      setLoading(false);
    }
  }

  const { successToast, errorToast } = useApplication();

  const handleInput = (ev) => {
    setForm([ev.currentTarget.name], ev.currentTarget.value);
  };

  const handleChange = (name, value) => {
    setForm([name], value);
  };


  const handleSave = async (ev) => {
    ev.preventDefault();
    setLoading(true);
    try {

      const formData = new FormData();
      Object.keys(form).forEach(key => formData.append(key, form[key]));

      formData.append('therapyId', therapy());

      if (key() !== null) {
        formData.append('id', key());
      }

      const data = await save(formData);

      if (data.success) {
        successToast(data.message);
        navigate("/therapy/" + therapy() + "/sessions");
        return;
      }

      errorToast(data.messages);
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };

  onMount(async () => {
  })

  return {
    loading,
    form,
    therapy,
    setTherapy,
    fetchInfo,
    handleSave,
    handleInput,
    handleChange
  };
}
